import { siteStats } from '@/mocks/siteStats';

const quickLinks = [
  { href: '#hot', icon: 'ri-fire-line', label: '热播剧集' },
  { href: '#tv', icon: 'ri-tv-2-line', label: '电视剧专区' },
  { href: '#movie', icon: 'ri-movie-2-line', label: '电影精选' },
  { href: '#collection', icon: 'ri-stack-line', label: '全集速看' },
];

const heroTags = ['电视剧全集', '院线新片', '高热剧集', '高清片源', '类型筛选'];

export default function Hero() {
  return (
    <section id="top" className="relative scroll-mt-16 bg-background-50 pt-24 pb-14 md:pt-28 md:pb-20">
      <div className="px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 text-xs rounded-full bg-accent-100 text-accent-800">
              <i className="ri-film-line"></i>
              内容类型与剧集资源导航
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-black leading-tight text-foreground-950">
              茶杯狐影视
              <span className="block mt-2 text-xl md:text-3xl font-bold text-primary-700">
                一站浏览电视剧、电影、热播剧与全集资源
              </span>
            </h1>

            <p className="mt-5 max-w-2xl text-sm md:text-base leading-7 text-foreground-600">
              本站围绕「内容类型与剧集资源」组织页面，把分散的影视条目按热播剧、电视剧、电影与全集分区整理，并对资源与片源情况做一般性说明。你可以先看热播榜单了解正在更新的剧集，再按类型标签筛选感兴趣的条目，最后参考片源与清晰度说明选择适合自己的观看档位。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {heroTags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 text-xs rounded-full bg-secondary-100 text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="#hot"
                className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium whitespace-nowrap rounded-md bg-primary-500 text-background-50 cursor-pointer transition-colors hover:bg-primary-600"
              >
                <i className="ri-play-circle-line"></i>
                查看热播剧
              </a>
              <a
                href="#genre"
                className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium whitespace-nowrap rounded-md border border-foreground-300 text-foreground-800 cursor-pointer transition-colors hover:bg-background-100"
              >
                <i className="ri-filter-3-line"></i>
                按类型筛选
              </a>
            </div>

            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
              {quickLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="group flex items-center gap-3 px-4 py-3 rounded-lg bg-background-100 border border-background-200 cursor-pointer transition-colors hover:border-primary-300"
                >
                  <span className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-100 text-primary-700">
                    <i className={`${link.icon} text-lg`}></i>
                  </span>
                  <span className="text-sm font-medium text-foreground-800">{link.label}</span>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative w-full h-[360px] md:h-[520px] rounded-lg overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20collage%20of%20glowing%20amber%20projector%20light%20beams%2C%20swirling%20film%20reels%2C%20vintage%20theater%20red%20velvet%20curtains%2C%20floating%20dust%20particles%2C%20rich%20crimson%20and%20golden%20orange%20palette%2C%20moody%20editorial%20poster%20texture%2C%20no%20text%2C%20high%20detail&width=880&height=1100&seq=cth-hero-01&orientation=portrait"
                alt="茶杯狐影视主题视觉：暖色影院光影与胶片元素构成的封面"
                className="w-full h-full object-top"
              />
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5 bg-gradient-to-t from-foreground-950/85 to-transparent">
                <p className="text-xs text-background-100/90">本期主题</p>
                <p className="mt-1 font-heading text-lg font-bold text-background-50">
                  热播与全集，一页看全
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {siteStats.map((stat) => (
            <div
              key={stat.id}
              className="px-4 py-4 md:px-5 md:py-5 rounded-lg bg-background-100 border border-background-200"
            >
              <p className="font-heading text-2xl md:text-3xl font-black text-primary-700">{stat.value}</p>
              <p className="mt-1.5 text-sm font-medium text-foreground-900">{stat.label}</p>
              <p className="mt-1 text-xs text-foreground-500">{stat.sub}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}